import { Injectable } from '@angular/core';
import { Observable, merge, of, fromEvent, map, shareReplay, pairwise } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  public isOnline$: Observable<boolean>;

  constructor() {
    this.isOnline$ = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false)),
    ).pipe(shareReplay(1));

    // To reload page once we back online
    this.isOnline$.pipe(pairwise()).subscribe(([wasOnline, isOnline]) => {
      if (!wasOnline && isOnline) {
        setTimeout(() => window.location.reload(), 500);
      }
    });
  }
}
